<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h4 class="grey--text text--lighten-1">{{ $t("warehouses.warehouse") }}</h4>
        <h2 class="mb-3">{{ warehouse !== null ? warehouse.name : '-' }}</h2>
        <edit-warehouse-form v-if="warehouse !== null" :warehouse="warehouse"/>
        <v-skeleton-loader v-else type="article"/>
    </layout-authenticated>
</template>

<script>
import SnackbarMixin from '@/mixins/SnackbarMixin'
import {API} from '@/api/api'
import EditWarehouseForm from '@/components/admin/forms/EditWarehouseForm'
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: 'Warehouse',
    mixins: [SnackbarMixin],
    components: {LayoutAuthenticated, EditWarehouseForm},
    data: () => ({
        // loading
        isBusyWarehouse: false,
        // warehouse
        warehouse: null
    }),
    computed: {
        isBusy() {
            return this.isBusyWarehouse;
        },
        warehouseId() {
            return this.$route.params.warehouseId;
        },
        breadcrumb() {
            return [
                {
                    text: this.$t('app.administration'),
                    href: '/admin'
                },
                {
                    text: this.$t('warehouses.warehouses'),
                    href: '/admin/warehouses'
                },
                {
                    text: this.warehouse?.name ?? this.$t('warehouses.warehouse'),
                    href: '/admin/warehouse/' + this.warehouseId,
                    disabled: true
                }
            ];
        }
    },
    methods: {
        fetchWarehouse() {
            this.isBusyWarehouse = true;
            API.get("/api/warehouses/" + this.warehouseId)
                .then(response => {
                    this.warehouse = response.data
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyWarehouse = false;
                });
        }
    },
    created() {
        this.fetchWarehouse();
    }
}
</script>
